/*!

=========================================================
* Argon Dashboard Chakra - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-chakra
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-chakra/blob/master/LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import {
  HashRouter,
  Route,
  Switch,
  Redirect,
  useHistory,
  useLocation,
} from "react-router-dom";

import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import AuthFLayout from "layouts/Face.js";
import AuthDLayout from "layouts/Dire.js";
import AuthILayout from "layouts/Insta.js";
import AuthWLayout from "layouts/Whatsa.js";
import RTLLayout from "layouts/RTL.js"; // Chakra imports
import { ChakraProvider } from "@chakra-ui/react";
import { AuthProvider } from "./components/UseContext/authContext";
// Custom Chakra theme
import theme from "theme/theme.js";
import "index.css";

const App = () => {
  const location = useLocation(); // Usa useLocation para obtener la ubicación actual
  useEffect(() => {
    console.log("Ruta actual:", location.pathname); // Muestra la ruta actual en la consola

    if (location.pathname === "/") {
      window.location.href = "/#/admin/dashboard";
      window.location.reload();
    } else if (location.pathname.substring(0, 3) === "/f/") {
      // Your logic here, for example:
      console.log("Path starts with /f/: ", location.pathname);
      // You could redirect or do some other action
    } else if (location.pathname.substring(0, 3) === "/d/") {
      // Your logic here, for example:
      console.log("Path starts with /d/: ", location.pathname);
      // You could redirect or do some other action
    } else if (location.pathname.substring(0, 3) === "/w/") {
      // Your logic here, for example:
      console.log("Path starts with /w/: ", location.pathname);
      // You could redirect or do some other action
    } else if (location.pathname.substring(0, 3) === "/i/") {
      // Your logic here, for example:
      console.log("Path starts with /i/: ", location.pathname);
      // You could redirect or do some other action
    } else if (location.pathname === "/admin/dashboard") {
      // Your logic here, for example:
      console.log("Path starts with /i/: ", location.pathname);
      // You could redirect or do some other action
    } else if (location.pathname === "/auth/signin") {
      // Your logic here, for example:
      console.log("Path starts with /i/: ", location.pathname);
      // You could redirect or do some other action
    } else if (location.pathname === "/auth/signup") {
      // Your logic here, for example:
      console.log("Path starts with /i/: ", location.pathname);
      // You could redirect or do some other action
    } else if (location.pathname === "/auth/logout") {
      // Your logic here, for example:
      console.log("Path starts with /i/: ", location.pathname);
      // You could redirect or do some other action
    } else if (location.pathname === "/admin/tables") {
      // Your logic here, for example:
      console.log("Path starts with /i/: ", location.pathname);
      // You could redirect or do some other action
    } else if (location.pathname === "/admin/profile") {
      // Your logic here, for example:
      console.log("Path starts with /i/: ", location.pathname);
      // You could redirect or do some other action
    } else if (location.pathname === "/admin/cashout") {
      // Your logic here, for example:
      console.log("Path starts with /i/: ", location.pathname);
      // You could redirect or do some other action
    } else if (location.pathname === "/admin/billing") {
      // Your logic here, for example:
      console.log("Path starts with /i/: ", location.pathname);
      // You could redirect or do some other action
    }
  }, [location]);

  return (
    <AuthProvider>
      <Switch>
        <Route path={`/admin`} component={AdminLayout} />
        <Route path={`/f/:id`} component={AuthFLayout} />
        <Route path={`/d/:id`} component={AuthDLayout} />
        <Route path={`/i/:id`} component={AuthILayout} />
        <Route path={`/w/:id`} component={AuthWLayout} />
        <Route path={`/auth`} component={AuthLayout} />
      </Switch>
    </AuthProvider>
  );
};

const Root = () => (
  <HashRouter>
    <App />
  </HashRouter>
);

ReactDOM.render(
  <ChakraProvider theme={theme} resetCss={false} position="relative">
    <Root />
  </ChakraProvider>,
  document.getElementById("root")
);
